module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAAXNSR0IArs4c6QAAAO1JREFUKBWtkc0Jg0AQhbMbG8glJXgQPQbsIfcVLEEIqSFFxBIErSEFBHL24iEdBBtYMG8kI+MmEvMjLDPOvPmY4SljzLHrumzxh08plesgCPZITr/yiNGzCJSm6cpae8am/jdgwBrP8+KiKFrFgCRJfAAJuuLanAhYixeXZdmQXvPQo2Dwb7k2I5LWMIz0SzlU1/U1iqIbttzK+lSutd5VVVXK/ghIDUAvYRiukW6k0M1xZg7Ywa0PJ8vGO+cB6x2VM5wPpnCB45TzgA2OslbGSSCJXOcBGzkqQZy/PJmbjvNPjrLu44hNM3pzBu/UNGI5pDFs4QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.png
// module id = lP78
// module chunks = 0